import { inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BreadCrumb } from '../models/common.models';
import {
  BREADCRUMB_SCHEME_CLASS,
  BreadCrumbSchema,
  IitemListElement, PRODUCT_SCHEME_CLASS,
  ProductSchema,
} from '../configurations/structured-data';
import { IAbstractProduct } from '../models/abstract-product.models';

@Injectable({
  providedIn: 'root',
})
export class StructuredDataService {
  private readonly scriptType: string = 'application/ld+json';
  private readonly selector: (className: string) => string = (className: string) => `script[type="${this.scriptType}"].${className}`;
  private readonly document: Document = inject(DOCUMENT);


  handleBreadcrumbSchema(breadcrumb: BreadCrumb[]): void {
    const listElement: IitemListElement[] = breadcrumb.map((item, index) => {
      return {
        '@type': 'ListItem',
        position: index + 1,
        name: item.label,
        item: this.buildUrl(item.url),
      };
    });
    const schema: Record<string, any> = BreadCrumbSchema(listElement);
    this.insertSchema(schema, BREADCRUMB_SCHEME_CLASS);
  }

  handleProductSchema(product: IAbstractProduct, images: string[]): void {
    const schema: Record<string, any> = ProductSchema(product, images);
    this.insertSchema(schema, PRODUCT_SCHEME_CLASS);
  }

  removeStructuredData(className: string): void {
    const scripts: NodeListOf<HTMLScriptElement> = this.document.head.querySelectorAll(this.selector(className));
    scripts.forEach((s: HTMLScriptElement) => s.remove());
  }

  insertSchema(schema: Record<string, any>, className: string = 'structured-data'): void {
    let script: HTMLScriptElement;
    let shouldAppend: boolean = false;
    const existing: HTMLScriptElement | null = this.document.head.querySelector(this.selector(className));
    if (existing) {
      script = existing;
    } else {
      script = this.document.createElement('script');
      shouldAppend = true;
    }
    script.setAttribute('class', className);
    script.type = this.scriptType;
    script.text = JSON.stringify(schema);
    if (shouldAppend) {
      this.document.head.appendChild(script);
    }
  }

  private buildUrl(url: string): string {
    const path: string = !url.startsWith('/') && url !== '' ? `/${url}` : url;
    return `${globalThis.location.origin}${path}`;
  }
}
